import React from "react"
import PropTypes from "prop-types"
import Card from "../../card"
import Grid from "../../grid"
import { H2, P } from "../../typography"

const Events = ({ events }) => (
  <Card marginless variant="primary">
    <Grid gap="1rem">
      <H2 marginless>Events</H2>
      {events.length > 0 ? (
        <Grid>
          {events.map((event, index) => (
            <Card key={`event_${index}`} variant="secondary">
              <Grid gap="0.5rem">
                <P marginless bold size="medium" variant="secondaryReadable">
                  {event.name}
                </P>
                <P marginless variant="secondaryReadable">
                  {event.event_type}
                </P>
              </Grid>
            </Card>
          ))}
        </Grid>
      ) : (
        <P marginless>Not attending any events.</P>
      )}
    </Grid>
  </Card>
)

Events.propTypes = {
  events: PropTypes.array.isRequired
}

Events.defaultProps = {
  events: []
}

export default Events
